import RadioButton from "@rio-cloud/rio-uikit/RadioButton";
import { OverlayTrigger, Tooltip, Dialog, Button } from "@rio-cloud/rio-uikit";

import { fetchConsultants } from "../../../../../api/fetchConsultants";

import { Loading } from "../../../../../utils/loading";

import { Dealership } from "../../../../../models/dealership";

import { IDateAndConsultantForm, useSchedulingFormDateAndConsultant } from "../../../../../hooks/useSchedulingForm";
import { useMediaQuery } from "@mui/material";


export interface IDateAndConsultantFormProps {
  dealership?: Dealership;
  setStep: (step: number) => void;
  form?: IDateAndConsultantForm;
  setAppointmentForm: (form: IDateAndConsultantForm) => void;
  isReschedule?: boolean;
}

const DateAndConsultantForm = ({
  dealership,
  setStep,
  form,
  setAppointmentForm,
  isReschedule,
}: IDateAndConsultantFormProps) => {
  const {
    consultantloading, setConsultantLoading,
    consultants, setConsultants,
    date, setDate,
    firstWeekDay, weekDays,
    previousWeek, nextWeek, getAvailableHours,
    showDialog, setShowDialog,
    dialogContent,
    handleNextStep
  } = useSchedulingFormDateAndConsultant(dealership, form);
  const isResponsiveView = useMediaQuery('(max-width: 1024px)');


  return (
    <>
      <Dialog
        show={showDialog}
        title={dialogContent.title}
        body={dialogContent.body}
        footer={
          <div className='display-flex justify-content-end'>
            <Button bsStyle='primary' onClick={() => setShowDialog(false)}>
              Fechar
            </Button>
          </div>
        }
        bsSize={Dialog.SIZE_XS}
        onClose={() => setShowDialog(false)}
      />
      <div className={`scheduling-page calendar-section ${isResponsiveView ? 'p-4' : 'p-10'}`}>
        <div className="scheduling-page__header">
          <h2 className="text-size-h2 text-color-black font-semibold text-uppercase">
            3. Agendamento
          </h2>
          <p className="text-color-status-resting text-size-16 padding-top-10 font-semibold">
            Concessionária:
          </p>
        </div>

        <div className={`${isResponsiveView ? 'flex flex-col items-start gap-2' : 'flex items-center justify-between'} border card-concessionaria selected margin-top-10 margin-bottom-20`}>
          <div className="flex flex-column w-full">
            <div className="flex justify-between items-center gap-6 w-full border-top-none border-right-none border-left-none border-width-2">
              <h3 className="flex items-center gap-6 font-semibold text-size-18 p-5">
                <div className="border border-gray-300 rounded p-2">
                  <span className="rioglyph rioglyph-workshop" />
                </div>
                {dealership?.name}
              </h3>
            </div>
            <p className="text-size-14 p-6">{dealership?.address}</p>
          </div>
        </div>

        <div className="mb-4">
          <p className="text-color-status-resting text-size-16 padding-top-10 font-semibold">
            Selecionar a data: *
          </p>
          <div className="calendar-row margin-top-10">
            <div className={`${isResponsiveView ? 'flex items-center gap-8 justify-center' : 'flex items-center justify-between'} mb-2 calendar-row__month`}>
              <button onClick={previousWeek}>
                <span className="rioglyph rioglyph-chevron-left text-color-status-available"></span>
              </button>
              <span className="text-size-16 text-color-status-resting font-semibold capitalize">
                {firstWeekDay
                  .toLocaleDateString("pt-BR", {
                    month: "long",
                    year: "numeric",
                  })
                  .replace(" de ", "/")}
              </span>
              <button onClick={nextWeek}>
                <span className="rioglyph rioglyph-chevron-right text-color-status-available"></span>
              </button>
            </div>
            <div className={`${isResponsiveView ? 'flex overflow-x-auto items-center justify-center ' : 'flex justify-center gap-20 pt-10'} text-center p-2 calendar-row__days`}>
              {(weekDays ?? []).map((weekDay: any) => (
                <button
                  key={`${weekDay.weekDay}_${weekDay.day}`}
                  className={`flex flex-col items-center gap-5 p-2 w-12 h-16 rounded-lg text-sm transition-all ${isResponsiveView ? 'w-[40px] p-1' : 'w-12 p-2'} h-16 text-sm
                                        ${weekDay.day ===
                      (form?.scheduleDate || date)
                        ?.getDate()
                        .toString()
                      ? "active-date text-white"
                      : "hover:bg-gray-200"
                    }`}
                  onClick={async () => {
                    setConsultantLoading(true);
                    setAppointmentForm({
                      consultant: undefined,
                      scheduleDate: undefined,
                    });
                    setDate(weekDay.date);
                    const consultants = await fetchConsultants(
                      weekDay.date,
                      dealership?.id ?? ""
                    );
                    setConsultants(consultants);
                    setConsultantLoading(false);
                  }}
                  disabled={weekDay.date < new Date(new Date().setHours(0, 0, 0, 0))}
                >
                  <span className="text-size-12 text-gray-600 text-lowercase">
                    {weekDay.weekDay}
                  </span>
                  <span
                    className={`font-medium flex items-center justify-center text-size-14 day-card ${weekDay.date < new Date(new Date().setHours(0, 0, 0, 0)) ? "bg-lighter" : ""}`}
                  >
                    {weekDay.day}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {consultantloading && <Loading label="Carregando consultores..." />}

        {!consultantloading && consultants.length !== 0 && (
          <div className="mb-6">
            <p className="text-color-status-resting text-size-16 padding-top-10 font-semibold">
              Selecionar o consultor: *
            </p>
            <div className="margin-top-20 consult-table">
              <table className="w-full table-fixed border-collapse">
                <thead>
                  <tr>
                    <th className="consultant-column text-left p-2 border-b text-size-14">
                      Consultor(a)
                    </th>
                    {getAvailableHours(date || new Date()).map((hour) => (
                      <th
                        key={hour}
                        className="hour-column text-center p-2 border-b text-size-14"
                      >
                        {hour}:00
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {consultants.map((consultant) => (
                    <tr key={consultant.id}>
                      <td className="p-2 border-b text-size-14 font-medium">
                        {consultant.name}
                      </td>
                      {getAvailableHours(date || new Date()).map((hour) => (
                        <td key={hour} className="p-1 border-b text-center">
                          {!date ||
                            consultant.scheduleDates
                              ?.map((scheduleDate) =>
                                scheduleDate.toLocaleString("pt-Br")
                              )
                              ?.includes(
                                new Date(
                                  date.setHours(hour, 0, 0, 0)
                                ).toLocaleString("pt-Br")
                              ) ? (
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip" allowOnTouch>
                                  Horário indisponível
                                </Tooltip>
                              }
                            >
                              <div className="ml-[-7px]">
                                <div className="rounded-circle w-[14px] h-[14px] bg-light margin-auto" />
                              </div>
                            </OverlayTrigger>
                          ) : (
                            <RadioButton
                              className="form-radio"
                              name="time-slot"
                              onChange={() => {
                                if (date) {
                                  setAppointmentForm({
                                    consultant: consultant.id
                                      ? consultant
                                      : undefined,
                                    scheduleDate: new Date(
                                      date.getFullYear(),
                                      date.getMonth(),
                                      date.getDate(),
                                      hour,
                                      0,
                                      0,
                                      0
                                    ),
                                  });
                                }
                              }}
                            />
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      {!isResponsiveView && (
        <div className="fixed bottom-0 left-[50px] right-0 bg-white border-t shadow-md p-4 z-40">
          <div className="page-info flex justify-between padding-15">
            {!isReschedule ? (
              <span className="text-color-status-resting font-size-14">
                Passo <strong className="text-color-danger">3</strong> de 4
              </span>
            ) : (
              <span />
            )}
            <span className="text-color-status-resting font-size-14">
              Agendamento
            </span>
          </div>
          <div className="flex justify-between navigation-buttons step-1">
            {!isReschedule ? (
              <button onClick={() => setStep(2)}>
                <span className="rioglyph rioglyph-arrow-left text-size-16"></span>{" "}
                Voltar
              </button>
            ) : (
              <span />
            )}
            <button
              onClick={() => handleNextStep(setStep)}
              className="px-4 py-2 btn btn-primary"
            >
              Finalizar {isReschedule ? "reagendamento" : "agendamento"}
            </button>
          </div>
        </div>
      )}
      {isResponsiveView && (
        <div className="fixed bottom-0 left-[50px] right-0 bg-white border-t shadow-md p-4 z-20">
          <div className="flex justify-between items-center">
            <button onClick={() => setStep(2)} className="flex items-center px-4 py-2">
              <span className="rioglyph rioglyph-arrow-left text-size-16 mr-1"></span>
              Voltar
            </button>
            {!isReschedule && (
              <div className="text-center text-color-status-resting text-md">
                Passo <strong className="text-color-danger">3</strong> de 4
              </div>
            )}
            <button
              onClick={() => handleNextStep(setStep)}
              className="px-4 py-2 btn btn-primary text-md"
            >
              {isReschedule ? 'Finalizar reagendamento' : 'Finalizar agendamento'}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default DateAndConsultantForm;
